import * as React from "react";

module.exports = [
  {
    title: "Rappeler le contenu du plan blanc",
    description:
      " et son inscription dans un écosystème plus large de réponse à des situations sanitaires exceptionnelles ;"
  },
  {
    title: "Analyser les enjeux de la mobilisation RH",
    description: " en cas de déclenchement du plan blanc et les limites des outils actuels ;"
  },
  {
    title: "Étudier les opportunités",
    description: " offertes par des outils numériques dans ce domaine"
  }
];



// WEBPACK FOOTER //
// ./assets/react/components/Landing/ObjectifsLivreBlanc2.tsx